import { useContext } from "react";
import FinanceSideNav from "../modules/finance/SideNav";
import CrmSideNav from "../modules/crm/SideNav";
import DocumentsSideNav from "../modules/documents/SideNav";
import Logo from "@serie3/freelancesplaceapi/Assets/img/logo.png";
import ProjectsSideNav from "../modules/projects/SideNav";
import SystemProfileContext from "@serie3/common/user/SystemProfileContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGaugeHigh } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const DashboardLink = () => {
  const location = useLocation();
  const isActive = location.pathname === "/";
  const [hovered, setHovered] = useState(false);

  return (
    <li style={{ listStyle: "none" }}>
      <Link
        to="/"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "9px 12px 9px 16px",
          marginRight: "12px",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: isActive ? 700 : 500,
          fontSize: "0.92rem",
          color: isActive ? "#1a73e8" : hovered ? "#1a73e8" : "#424242",
          background: isActive ? "#e8f0fe" : hovered ? "#f5f9ff" : "transparent",
          transition: "background 0.15s, color 0.15s",
        }}
      >
        <span style={{ width: "20px", textAlign: "center", fontSize: "1rem", color: isActive ? "#1a73e8" : "#9e9e9e", flexShrink: 0 }}>
          <FontAwesomeIcon icon={faGaugeHigh} />
        </span>
        <span>Dashboard</span>
      </Link>
    </li>
  );
};

const Sidebar = () => {
  const { systemProfile } = useContext(SystemProfileContext);
  const firstName = systemProfile?.vorname || "";
  const initials = firstName ? firstName[0].toUpperCase() : "U";

  return (
    <>
      <style>{`
        .main-sidebar { background: #fff !important; box-shadow: 2px 0 12px rgba(0,0,0,0.08) !important; }
        .main-sidebar, .main-sidebar::before { background: #fff !important; }
        .sidebar { background: #fff !important; }
      `}</style>

      <aside className="main-sidebar elevation-0" style={{
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}>

        {/* Logo */}
        <div style={{
          padding: "22px 20px 18px",
          background: "linear-gradient(135deg, #1a237e 0%, #1a73e8 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}>
          <img
            src={Logo}
            alt="Freelancersplace"
            style={{ maxWidth: "150px", maxHeight: "52px", objectFit: "contain" }}
          />
        </div>

        {/* User panel */}
        <div style={{
          margin: "16px 12px",
          padding: "12px 14px",
          background: "linear-gradient(135deg, #e8f0fe 0%, #f3e8ff 100%)",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexShrink: 0,
        }}>
          <div style={{
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            background: "#1a73e8",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: "1rem",
            flexShrink: 0,
          }}>
            {initials}
          </div>
          <div>
            <div style={{ fontSize: "0.72rem", color: "#9e9e9e", fontWeight: 500 }}>Welcome back</div>
            <div style={{ fontSize: "0.92rem", fontWeight: 700, color: "#212121" }}>{firstName || "User"}</div>
          </div>
        </div>

        {/* Navigation */}
        <div className="sidebar" style={{
          background: "#fff",
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: "24px",
        }}>
          <nav>
            <ul style={{ listStyle: "none", padding: "0 0 0 0", margin: 0 }}>
              <DashboardLink />
              <FinanceSideNav />
              <CrmSideNav />
              <ProjectsSideNav />
              <DocumentsSideNav />
            </ul>
          </nav>
        </div>

      </aside>
    </>
  );
};

export default Sidebar;
